export const CREATE_PATIENT = {
  REQUEST: "CREATE_PATIENT_REQUEST",
  SUCCESS: "CREATE_PATIENT_SUCCESS",
  FAIL: "CREATE_PATIENT_FAIL",
};

export const GET_PATIENT = {
  REQUEST: "GET_PATIENT_REQUEST",
  SUCCESS: "GET_PATIENT_SUCCESS",
  FAIL: "GET_PATIENT_FAIL",
};

export const GET_PATIENTS = {
  REQUEST: "GET_PATIENTS_REQUEST",
  SUCCESS: "GET_PATIENTS_SUCCESS",
  FAIL: "GET_PATIENTS_FAIL",
};

export const UPDATE_PATIENT = {
  REQUEST: "UPDATE_PATIENT_REQUEST",
  SUCCESS: "UPDATE_PATIENT_SUCCESS",
  FAIL: "UPDATE_PATIENT_FAIL",
};

export const DELETE_PATIENT = {
  REQUEST: "DELETE_PATIENT_REQUEST",
  SUCCESS: "DELETE_PATIENT_SUCCESS",
  FAIL: "DELETE_PATIENT_FAIL",
};

export const CREATE_CONTACT = {
  REQUEST: "CREATE_CONTACT_REQUEST",
  SUCCESS: "CREATE_CONTACT_SUCCESS",
  FAIL: "CREATE_CONTACT_FAIL",
};
export const UPDATE_CONTACT = {
  REQUEST: "UPDATE_CONTACT_REQUEST",
  SUCCESS: "UPDATE_CONTACT_SUCCESS",
  FAIL: "UPDATE_CONTACT_FAIL",
};
export const DELETE_CONTACT = {
  REQUEST: "DELETE_CONTACT_REQUEST",
  SUCCESS: "DELETE_CONTACT_SUCCESS",
  FAIL: "DELETE_CONTACT_FAIL",
};
export const CREATE_COMMENT = {
    REQUEST: "CREATE_COMMENT_REQUEST",
    SUCCESS: "CREATE_COMMENT_SUCCESS",
    FAIL: "CREATE_COMMENT_FAIL",
  };
export const GET_COMMENT = {
  REQUEST: "GET_COMMENT_REQUEST",
  SUCCESS: "GET_COMMENT_SUCCESS",
  FAIL: "GET_COMMENT_FAIL",
};
export const DELETE_COMMENT = {
  REQUEST: "DELETE_COMMENT_REQUEST",
  SUCCESS: "DELETE_COMMENT_SUCCESS",
  FAIL: "DELETE_COMMENT_FAIL",
};

export const CREATE_CONTACT_TYPE = {
  REQUEST: "CREATE_CONTACT_TYPE_REQUEST",
  SUCCESS: "CREATE_CONTACT_TYPE_SUCCESS",
  FAIL: "CREATE_CONTACT_TYPE_FAIL",
};

export const GET_CONTACT_TYPE = {
  REQUEST: "GET_CONTACT_TYPE_REQUEST",
  SUCCESS: "GET_CONTACT_TYPE_SUCCESS",
  FAIL: "GET_CONTACT_TYPE_FAIL",
};

export const DELETE_CONTACT_TYPE = {
  REQUEST: "DELETE_CONTACT_TYPE_REQUEST",
  SUCCESS: "DELETE_CONTACT_TYPE_SUCCESS",
  FAIL: "DELETE_CONTACT_TYPE_FAIL",
};

export const ADD_PATIENT_FILE = {
  REQUEST: "ADD_PATIENT_FILE_REQUEST",
  SUCCESS: "ADD_PATIENT_FILE_SUCCESS",
  FAIL: "ADD_PATIENT_FILE_FAIL",
};
export const DELETE_PATIENT_FILE = {
  REQUEST: "DELETE_PATIENT_FILE_REQUEST",
  SUCCESS: "DELETE_PATIENT_FILE_SUCCESS",
  FAIL: "DELETE_PATIENT_FILE_FAIL",
};

export const ASSIGN_PATIENT_DOCTOR = {
  REQUEST: "ASSIGN_PATIENT_DOCTOR_REQUEST",
  SUCCESS: "ASSIGN_PATIENT_DOCTOR_SUCCESS",
  FAIL: "ASSIGN_PATIENT_DOCTOR_FAIL",
};

export const UN_ASSIGN_PATIENT_DOCTOR = {
  REQUEST: "UN_ASSIGN_PATIENT_DOCTOR_REQUEST",
  SUCCESS: "UN_ASSIGN_PATIENT_DOCTOR_SUCCESS",
  FAIL: "UN_ASSIGN_PATIENT_DOCTOR_FAIL",
};

export const GET_COMMENT_TYPE = {
  REQUEST: "GET_COMMENT_TYPE_REQUEST",
  SUCCESS: "GET_COMMENT_TYPE_SUCCESS",
  FAIL: "GET_COMMENT_TYPE_FAIL",
};

export const CREATE_COMMENT_TYPE = {
  REQUEST: "CREATE_COMMENT_TYPE_REQUEST",
  SUCCESS: "CREATE_COMMENT_TYPE_SUCCESS",
  FAIL: "CREATE_COMMENT_TYPE_FAIL",
};

export const DELETE_COMMENT_TYPE = {
  REQUEST: "DELETE_COMMENT_TYPE_REQUEST",
  SUCCESS: "DELETE_COMMENT_TYPE_SUCCESS",
  FAIL: "DELETE_COMMENT_TYPE_FAIL",
};
